import React from 'react';
import { InPageSpinner } from '@components/spinners/in-page-spinner';
import { StatusBadge } from '@components/status-badge';
import { AirflowTaskInstance } from './types';
import { taskInstanceStateVariant } from './utils';
import styles from './styles.module.scss';

type AffectedTasksTableProps = {
    tasks: AirflowTaskInstance[];
    isLoading: boolean;
};

/*
 * Dry-run preview table shown by the Clear Task and Clear DAG Run dialogs
 */
export function AffectedTasksTable({ tasks, isLoading }: AffectedTasksTableProps) {
    if (isLoading) return <InPageSpinner size="Small" />;
    if (tasks.length === 0) return <div className={styles.card}>No tasks would be affected.</div>;

    return (
        <table style={{ width: '100%', fontSize: 12, letterSpacing: 0.25, borderCollapse: 'separate', borderSpacing: 0 }}>
            <thead>
                <tr style={{ background: '#212233', textAlign: 'left' }}>
                    <th style={{ padding: '8px 12px', fontWeight: 700, color: '#fff' }}>Task ID</th>
                    <th style={{ padding: '8px 12px', fontWeight: 700, color: '#fff' }}>State</th>
                    <th style={{ padding: '8px 12px', fontWeight: 700, color: '#fff' }}>Map Index</th>
                    <th style={{ padding: '8px 12px', fontWeight: 700, color: '#fff' }}>Run ID</th>
                </tr>
            </thead>
            <tbody>
                {tasks.map((task, index) => (
                    <tr
                        key={`${task.dag_run_id}-${task.task_id}-${task.map_index ?? -1}`}
                        style={{ background: index % 2 === 0 ? '#212233' : '#14182a', fontWeight: 700 }}
                    >
                        <td style={{ padding: '8px 12px', fontFamily: 'monospace' }}>{task.task_id}</td>
                        <td style={{ padding: '8px 12px' }}>
                            <StatusBadge variant={taskInstanceStateVariant(task.state)}>{task.state ?? 'none'}</StatusBadge>
                        </td>
                        <td style={{ padding: '8px 12px' }}>{task.map_index !== undefined && task.map_index >= 0 ? task.map_index : '—'}</td>
                        <td style={{ padding: '8px 12px', fontFamily: 'monospace' }}>{task.dag_run_id}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
